import React from 'react';
import { Link } from 'react-router-dom';
import PageWrapper from '../PageWrapper';
import { getNosotrosPageData } from '../../../services/nosotros';
import NosotrosHero from './sections/NosotrosHero';
import NosotrosDynamicSection from './sections/NosotrosDynamicSection';
import NosotrosFAQ from './sections/NosotrosFAQ';
import NosotrosGlossary from './sections/NosotrosGlossary';
import AlliancesSection from '../Homepage/seccions/AlliancesSection';
import SEO from '../../common/SEO';
import { Box, Typography, Container, Button } from '@mui/material';

const Nosotros = () => {
    return (
        <PageWrapper
            fetchData={getNosotrosPageData}
            render={(data) => {
                if (!data) return null;

                // Compatible with both Strapi v4 (data.attributes) and v5 (flat data)
                const content = data.attributes || data;
                const { hero, sections, faqs, glossary, cta_text, cta_button_text, alliances, seo } = content || {};

                return (
                    <Box className="nosotros-page">
                        <SEO 
                            title="Nosotros | E2E Travel Solutions — Equipo, visión y experiencia en travel tech"
                            description="Somos un equipo interdisciplinario de travel tech. Diseñamos soluciones centradas en el usuario para digitalizar procesos y escalar negocios turísticos."
                        />
                        <NosotrosHero data={hero} />

                        {sections && sections.map((section, index) => (
                            <NosotrosDynamicSection key={index} data={section} />
                        ))}

                        {alliances && alliances.length > 0 && (
                            <AlliancesSection data={alliances} />
                        )}

                        {(cta_text || cta_button_text) && (
                            <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: '#fbfcfd', textAlign: 'center' }}>
                                <Container maxWidth="md">
                                    <Typography variant="h3" sx={{ 
                                        mb: 3, 
                                        fontWeight: 800, 
                                        color: '#4e429c',
                                        fontSize: { xs: '2rem', md: '3rem' }
                                    }}>
                                        {cta_text.split('||')[0]}
                                    </Typography>
                                    
                                    {cta_text.includes('||') && (
                                        <Typography variant="h6" sx={{ 
                                            mb: 5, 
                                            color: '#666', 
                                            fontWeight: 400,
                                            maxWidth: '700px',
                                            mx: 'auto',
                                            lineHeight: 1.6
                                        }}>
                                            {cta_text.split('||')[1]}
                                        </Typography>
                                    )}

                                    <Button 
                                        component={Link}
                                        to="/contact"
                                        variant="contained" 
                                        size="large"
                                        sx={{ 
                                            bgcolor: '#F3B33D', 
                                            color: 'white',
                                            px: 6,
                                            py: 2,
                                            borderRadius: 10,
                                            fontSize: '1.1rem',
                                            fontWeight: 700,
                                            textTransform: 'none',
                                            boxShadow: '0 10px 30px rgba(243, 179, 61, 0.3)',
                                            '&:hover': {
                                                bgcolor: '#e2a12d',
                                                boxShadow: '0 15px 40px rgba(243, 179, 61, 0.4)',
                                                transform: 'translateY(-2px)'
                                            },
                                            transition: 'all 0.3s ease'
                                        }}
                                    >
                                        {cta_button_text}
                                    </Button>
                                </Container>
                            </Box>
                        )}

                        {faqs && faqs.length > 0 && (
                            <NosotrosFAQ data={faqs} />
                        )}

                        {glossary && glossary.length > 0 && (
                            <NosotrosGlossary data={glossary} />
                        )}
                    </Box>
                );
            }}
        />
    );
};

export default Nosotros;
